export const convertTelegrammMenuToArray = menu => {
    if (menu) {
        let linksObj = {};
        try {
            linksObj = JSON.parse(menu);
        } catch (e) {
            return console.error(e); // error in the above string (in this case, yes)!
        }
        if (linksObj.inline_keyboard?.length > 0) {
            const linksArray = linksObj.inline_keyboard.flatMap(arr =>
                arr.map(item => {
                    const name = item.text; // Получаем значение "text"
                    const value = item.url; // Получаем значение "url"
                    const id = `${name}${value}`; // Создаем id на основе name и value
                    return { linkKey: name, linkValue: value, id }; // Возвращаем новый объект
                })
            );

            return linksArray;
        }
    }

    return [];
};
